// extracted by mini-css-extract-plugin
export var avatarContainer = "_dk-0";
export var avatarTypingWave = "_dk-i";
export var gray = "_dk-f";
export var green = "_dk-c";
export var icon = "_dk-9";
export var image = "_dk-1";
export var lg = "_dk-6";
export var md = "_dk-5";
export var presenceDot = "_dk-b";
export var red = "_dk-d";
export var sm = "_dk-4";
export var status = "_dk-a";
export var typingDot = "_dk-h";
export var typingPill = "_dk-g";
export var xl = "_dk-7";
export var xs = "_dk-3";
export var xxl = "_dk-8";
export var xxs = "_dk-2";
export var yellow = "_dk-e";